export default __webpack_public_path__ + "static/media/star.9bf1f3ff.png";